interface RichTextProps {
  content?: string;
}

export function RichTextBlock({ props }: { props: RichTextProps }) {
  return (
    <div
      className="prose prose-zinc max-w-none"
      dangerouslySetInnerHTML={{ __html: props.content ?? '' }}
    />
  );
}
